import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

/**
 * Componente que renderiza a tabela de processos.
 * @param {Array} rows - Dados das linhas da tabela.
 * @param {Array} columns - Definições das colunas da tabela.
 * @param {Function} onRowClick - Função chamada ao clicar em uma linha.
 */
function ProcessTable({ rows, columns, onRowClick }) {
    return (
        <div style={{ height: '100%', width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                pagination
                checkboxSelection={false}
                disableSelectionOnClick
                autoHeight
                getRowHeight={() => 'auto'}
                onRowClick={onRowClick}
                sx={{
                    '& .MuiDataGrid-cell': {
                        whiteSpace: 'normal',
                        lineHeight: '1.5',
                        wordBreak: 'break-word',
                        overflow: 'hidden',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid #000',
                    },
                    '& .MuiDataGrid-cell': {
                        borderRight: '1px solid #ccc',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    '& .MuiDataGrid-row': {
                        borderBottom: '1px solid #ccc',
                    },
                }}
            />
        </div>
    );
}

export default ProcessTable;
